import { memo, useState } from 'react';
import { forEach, append, includes } from 'ramda';
import { useSnackbar } from 'notistack';

import { withNotifications } from 'hoc';
import { useEffectBoundary } from 'effects';

const shouldUpdate = ({ notifications: oldNotifications = [] }, { notifications: newNotifications = [] }) => {
  let notExists = false;
  for (let i = 0; i < newNotifications.length; i += 1) {
    if (notExists) continue;
    notExists = notExists || !oldNotifications.filter(({ key }) => newNotifications[i].key === key).length;
  }

  return notExists;
};

const NotificationsInner = ({ notifications = [], removeNotification }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [displayed, setDisplayed] = useState([]);

  useEffectBoundary(() => {
    forEach(({ key, message, options }) => {
      if (!key || includes(key, displayed)) return;

      enqueueSnackbar(message, options);
      setDisplayed(append(key, displayed));
      removeNotification(key);
    }, notifications);
  }, [notifications]);

  return null;
};

export const Notifications = withNotifications(NotificationsInner);
export default memo(Notifications, shouldUpdate);
